<template>
	<div class="contentbox">
		<!--<ul class="tabs-ul-list">-->
            <!--<li v-for="(item, index) in tabName" :key="index">-->
                <!--<a :class="item.value === tabValue ? 'active' : ''" @click="tabChange(item.value)">{{item.name}}</a>-->
            <!--</li>-->
        <!--</ul>-->
		<!--<div class="tabs-ul-con" style="padding-top: 30px;">-->
			<!--&lt;!&ndash; 广告补回传组件 &ndash;&gt;-->
			<!--<ad-return-list v-if="tabValue == 1"> </ad-return-list>-->
			<!--&lt;!&ndash; 付费补回传组件 &ndash;&gt;-->
			<!--<recharge-return-list v-if="tabValue == 2"> </recharge-return-list>-->
		<!--</div>-->
		<recharge-return-list :tfId="tfId"> </recharge-return-list>
		<agent-pop :visible.sync="isShowDialogAgent"></agent-pop>
	</div>
</template>
<script>
import AgentPop from '@/components/AgentPop'
// import AdReturnList from '@/components/AdReturnList'
import RechargeReturnList from '@/views/wb/data/RechargeReturnList'
// import { list, addRepair } from "@/api/wb/data/return";
export default {
    components: {
        AgentPop,
		// AdReturnList,
		RechargeReturnList
    },
	data() {
		return {
			// tabValue:1,
			tfId: '',
			isShowDialogAgent: false,
            // tabName: [
            //     {
            //         value: 1,
            //         name: '广告补回传'
            //     },{
            //         value: 2,
            //         name: '付费补回传'
            //     },
            // ],
		}
	},
	computed: {},
	watch: {},
	created () {
		if(JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
			this.isShowDialogAgent = false
		} else {
			this.isShowDialogAgent = true
		}
	},
	mounted: function() {
        this.tfId = this.$route.query.id
        console.log(this.tfId)
	},
	methods: {
		// tabChange(val){
		// 	this.tabValue = val;
		// }
	}
}
</script>
<style lang="scss">
.media-tab{
	display: flex;
	.media-tab-title{
		width: 120px;
		height: 40px;
		border: 1px solid #afb0b3;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #606266;
		margin-bottom: 20px;
		margin-right: 10px;
	}
	.tab-select{
		color: #409eff;
		border: 1px solid #409eff;
	}
}
</style>
